export default __webpack_public_path__ + "static/media/minus.9d5f4982.svg";